const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.entrances/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.entrances/LIST_ENTRANCES_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
